import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class KPIMetricInfoModel extends BaseModel {
  @attr("string") value;
  @attr("string") header;
  @attr("string") colorState;
  @attr("string") arrowState;
}
